module.exports = __webpack_public_path__ + "img/zd2.8687e51d.png";